package com.example.mystybag.core.model

import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Immutable
import androidx.compose.ui.text.input.ImeAction
import com.arkivanov.decompose.value.Value
import dev.icerock.moko.resources.ImageResource
import kotlinx.coroutines.flow.MutableStateFlow

data class AdditionalIcon(
    val image   : ImageResource,
    val action  : () -> Unit
)

data class SmallButtonModel(
    val title   : String,
    val icon    : ImageResource?,
    val onClick : () -> Unit
)

data class UINavigationState(
    var title               : String                            = "",
    var navVisible          : Boolean                           = true,
    var backButtonVisible   : Boolean                           = true,
    var additionalIcons     : List<AdditionalIcon>?             = null,
    var leadingIcon         : ImageDescription?                 = null,
    var keyboardOptions     : KeyboardOptions                   = KeyboardOptions(imeAction = ImeAction.Done),
    var smallButtons        : List<ButtonImageVisualModel>?     = null
)

data class UISearchTextFieldState(
    var openSearch  : MutableStateFlow<Boolean> = MutableStateFlow(false),
    var searchText  : MutableStateFlow<String>  = MutableStateFlow("")
)

interface UINavigationCallbacks {
    val controls: Value<UINavigationState>
    fun backButtonCallback()
}

@Immutable
interface UISearchCallbacks {
    val state       : UISearchTextFieldState
    var openSearch  : Boolean
    var searchText  : String

    fun onSearchTextChanged(search: String)
    fun onKeyboardAction(imeAction: ImeAction): Boolean
}